import { PREFERRED_FORECASTS_VIEW_TYPE } from 'constants/user';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveUserProperty } from 'redux/modules/user.actions';
import type { ThunkDispatch } from 'types/redux';
import { getForecastsViewType } from '../redux/modules/forecast.selectors';
import type { ForecastViewType } from '../types/forecast';

export const useActiveForecastViewType = () => {
  const activeViewType = useSelector(getForecastsViewType);
  const dispatch = useDispatch<ThunkDispatch>();
  const setActiveViewType = useCallback(
    (viewType: ForecastViewType) => {
      dispatch(saveUserProperty(PREFERRED_FORECASTS_VIEW_TYPE, viewType));
    },
    [dispatch]
  );

  return {
    activeViewType,
    setActiveViewType,
  } as const;
};
